<template>
  <div class="bookings">
    <b-container>
      <h1>Appointments</h1>
      <b-row>
        <b-col>
          <b-form-group label-for="filterCriteria">
            <b-input-group>
              <b-form-input type="text" id="filterCriteria" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
              <b-input-group-append>
                <b-button @click="cleanFilterInfo()" variant="primary"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
      </b-row>

      <b-pagination
        v-model="currentPage"
        :page="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table"
      ></b-pagination>

      <b-button variant="primary" @click="showModal('modal-add-booking')">Add appointment</b-button>

      <b-table
        class="pointer mt-2"
        id="my-table"
        responsive
        striped
        hover
        @row-clicked="myRowClickHandler"
        :fields="booking_fields"
        :filter="filterCriteria"
        :filter-included-fields="filterOn"
        :items="bookings"
        :per-page="perPage"
        :current-page="currentPage"
        :busy="tableIsBusy"
        small
      >
    
      <template #cell(actions)="row">
        <b-button class="table-button" size=sm variant="primary" @click="view_booking(row.item)">View</b-button>
        <b-button class="table-button ml-1" size=sm variant="danger" @click="delete_booking(row.item.id)">Delete</b-button>
      </template>
      
      </b-table>
    </b-container>

    <b-modal id="modal-delete-booking"
      title="Delete confirmation"
      hide-footer>
      <p>This operation will delete a booking.</p>
      <div class="modal-footer mt-1">
        <b-button variant="secondary" @click="hideModal('modal-delete-booking')"> Cancel </b-button>
        <b-button type="submit" variant="primary" @click="delete_booking_task()"> Delete </b-button>
      </div>
    </b-modal>


    <!-- new_booking: {
      id: "",
      date: "",
      customer_name: "",
      customer_phone: "",
      how_did_you_find_us: "",
      cemetery_name: "",
      funeral_provider: "",
      customer_enquiry: "",
      follower: "",
      created_by: "",
      created_by_name: ""
    } -->

    <!-- ADD BOOKING -->
    <b-modal id="modal-add-booking" hide-footer title="Add booking">
      <b-form @submit.prevent="add_booking">
        <label for="booking_date">Date:</label>
        <b-form-datepicker type="date"
          id="booking_date"
          v-model="new_booking.date"
          class="form-control"></b-form-datepicker>

        <label for="booking_time">Time:</label>
        <b-input-group class="mb-3">
          <b-form-input
            v-model="new_booking.time"
            id="new-booking-time-input"
            type="text"
            placeholder="HH:mm:ss"
            required
          ></b-form-input>
          <b-input-group-append>
            <b-form-timepicker
              v-model="new_booking.time"
              required
              button-only
              right
              locale="en"
              aria-controls="new-booking-time-input"
            ></b-form-timepicker>
          </b-input-group-append>
        </b-input-group>

        <label for="customer_name">Customer Name:</label>
        <b-input type="text" 
          id="customer_name" 
          v-model="new_booking.customer_name" 
          required></b-input>

        <label for="customer_phone">Customer Phone:</label>
        <b-input type="text" 
          id="customer_phone" 
          v-model="new_booking.customer_phone" 
          ></b-input>
        
        <label for="customer_email">Customer Email:</label>
        <b-input id="customer_email" v-model="new_booking.email"></b-input>

        <label for="how_did_you_find_us">How did you find us:</label>
        <b-form-select id="how_did_you_find_us"
          v-model="new_booking.how_did_you_find_us" 
          :options="lead_source_names"
          required></b-form-select>

        <label for="cemetery_name">Cemetery Name:</label>
        <b-input type="text" 
          id="cemetery_name" 
          v-model="new_booking.cemetery_name" 
          ></b-input>

        <label for="funeral_provider">Funeral Provider:</label>
        <b-form-select id="follower"
          v-model="new_booking.funeral_provider" 
          :options="funeral_provider_names"
          ></b-form-select>

        <label for="follower">Who is following:</label>
        <!-- <p v-if="this.user.role == 'sales'">{{this.user.name}}</p> -->
        <b-form-select
          id="follower"
          v-model="new_booking.follower" 
          :options="sales_names"
          required></b-form-select>


        <label for="customer_enquiry">Customer Enquiry:</label>
        <b-textarea type="text" 
          id="customer_enquiry" 
          v-model="new_booking.customer_enquiry" 
          ></b-textarea>
          
        <div class="modal-footer">
          <b-button @click="hideModal('modal-add-booking')"> Cancel </b-button>
          <b-button type="submit" variant="primary">Submit</b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- VIEW BOOKING -->
    <b-modal id="modal-view-booking" hide-footer title="View booking">
      <b-form @submit.prevent="add_booking">
        <strong>Date:</strong>
        <b-form-datepicker type="date"
          v-model="viewed_booking.date"
          required
          class="form-control"></b-form-datepicker>

        <strong>Time:</strong>
        <b-input-group class="mb-3">
          <b-form-input
            v-model="viewed_booking.time"
            id="viewed-booking-time-input"
            type="text"
            placeholder="HH:mm:ss"
            required
          ></b-form-input>
          <b-input-group-append>
            <b-form-timepicker
              v-model="viewed_booking.time"
              required
              button-only
              right
              locale="en"
              aria-controls="viewed-booking-time-input"
            ></b-form-timepicker>
          </b-input-group-append>
        </b-input-group>

        <strong>Customer Name:</strong>
        <b-input type="text"
          v-model="viewed_booking.customer_name" 
          required></b-input>

        <strong>Customer Phone:</strong>
        <b-input v-model="viewed_booking.customer_phone"></b-input>

        <strong>Customer Email:</strong>
        <b-input v-model="viewed_booking.email"></b-input>

        <strong>How did you find us:</strong>
        <b-form-select id="how_did_you_find_us"
          v-model="viewed_booking.how_did_you_find_us" 
          :options="lead_source_names"
          ></b-form-select>

        <strong>Cemetery Name:</strong>
        <b-input v-model="viewed_booking.cemetery_name"></b-input>

        <strong>Funeral Provider:</strong>
        <b-form-select v-model="viewed_booking.funeral_provider"
          :options="funeral_provider_names"
          required></b-form-select>

        <strong>Who is following:</strong>
        <b-form-select v-model="viewed_booking.follower"
          :options="sales_names"
          required></b-form-select>

        <strong>Customer Enquiry:</strong>
        <b-textarea v-model="viewed_booking.customer_enquiry"></b-textarea>
          
        <div class="modal-footer">
          <b-button @click="hideModal('modal-view-booking')"> Return </b-button>
          <b-button variant="warning" @click="edit_booking"> Update </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default ({
  props: {
    user: Object,
  },
  data() {
    return {
      original_follower: '',
      funeral_providers: [],
      funeral_provider_names: [],
      lead_sources: [],
      lead_source_names: [],
      sales: [],
      sales_names: [],
      perPage: 20,
      currentPage: 1,
      filterCriteria: "",
      quotes: [],
      tableIsBusy: false,
      deleted_booking_id: "",
      booking_fields: [
        { key: 'date', label: 'Date'},
        { key: 'time', label: 'Time'},
        { key: 'customer_name', label: 'Customer Name'},
        { key: 'customer_phone', label: 'Customer Phone'},
        { key: 'follower', label: 'Who is following'},
        { key: "actions", label: "Actions"}
      ],
      bookings: [],
      new_booking: {
        id: "",
        date: "",
        time: "00:00:00",
        email: "",
        created_date: "",
        customer_name: "",
        customer_phone: "",
        how_did_you_find_us: "",
        cemetery_name: "",
        funeral_provider: "",
        customer_enquiry: "",
        follower: "",
        created_by: "",
        created_by_name: "",
        status: "incomplete"
      },
      viewed_booking: {
        id: "",
        date: "",
        created_date: "",
        customer_name: "",
        customer_phone: "",
        how_did_you_find_us: "",
        cemetery_name: "",
        funeral_provider: "",
        customer_enquiry: "",
        follower: "",
        created_by: "",
        created_by_name: "",
        status: ""
      },
      filterOn: ['date', 'time', 'customer_name', 'customer_phone', 'follower'],
    }
  },
  computed: {
    rows: {
      get() {
        if (this.bookings.length == 0) {
          return 100;
        } else {
          return this.bookings.length;
        }
      },
      set(newRows) {
        return newRows
      }
    },
  },
  created() {
    this.set_global_date();

    // if (this.user.role == "sales") {
    //   firebase.firestore().collection("bookings").where("follower", "==", this.user.name).orderBy('date', "desc").orderBy('time', "desc").onSnapshot((collection) => {
    //     this.bookings = [];
    //     this.bookings = collection.docs.map(doc => doc.data());
    //     this.rows = this.bookings.length;
    //   });
    // } else {
    //   firebase.firestore().collection("bookings").orderBy('date', "desc").orderBy('time', "asc").onSnapshot((collection) => {
    //     this.bookings = [];
    //     this.bookings = collection.docs.map(doc => doc.data());
    //     this.rows = this.bookings.length;
    //   });
    // }
    firebase.firestore().collection("bookings").orderBy('date', "desc").orderBy('time', "asc").onSnapshot((collection) => {
      this.bookings = [];
      this.bookings = collection.docs.map(doc => doc.data());
      this.rows = this.bookings.length;
    });

    firebase.firestore().collection("saless").onSnapshot((collection) => {
      this.sales = [];
      this.sales_names = [];
      this.sales = collection.docs.map(doc => doc.data());
      for (var i = 0; i < this.sales.length; i++) {
        this.sales_names.push(this.sales[i].name);
      }
    });

    firebase.firestore().collection('lead_sources').orderBy('name').onSnapshot((collection) => {
      this.lead_sources = [];
      this.lead_sources = collection.docs.map(doc => doc.data());
      for (var i = 0; i < this.lead_sources.length; i++) {
        this.lead_source_names.push(this.lead_sources[i].name);
      }
    });

    firebase.firestore().collection('funeral_providers').orderBy('name').onSnapshot((collection) => {
      this.funeral_providers = [];
      this.funeral_providers = collection.docs.map(doc => doc.data());
      for (var i = 0; i < this.funeral_providers.length; i++) {
        this.funeral_provider_names.push(this.funeral_providers[i].name);
      }
    });
  },
  methods: {
    myRowClickHandler(item) {
      console.log(item);
    },
    delete_booking(id) {
      if (this.user.role != "admin") {
        alert("You do not have authority.");
      } else {
        this.deleted_booking_id = id;
        this.showModal("modal-delete-booking");
      }
    },
    delete_booking_task() {
      firebase.firestore().collection("bookings").doc(this.deleted_booking_id).delete()
        .then(() => {
          this.hideModal("modal-delete-booking");
          alert("delete successfully");
        });
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    add_booking() {
      const new_booking_ref = firebase.firestore().collection("bookings").doc();

      this.new_booking.id = new_booking_ref.id;
      this.new_booking.created_date = this.today;
      this.new_booking.year_month = this.new_booking.date.substring(0, 7);
      this.new_booking.day = parseInt(this.new_booking.date.substring(8,10));
      this.new_booking.created_by = this.user;
      this.new_booking.created_by_name = this.user.name;
      new_booking_ref.set(this.new_booking).then(() => {
        this.hideModal("modal-add-booking");
        
        firebase.firestore()
          .collection("users")
          .where("name", "==", this.new_booking.follower)
          .onSnapshot((collection) => {
          var results = collection.docs.map(doc => doc.data());
          var recipient = results[0]

          var email = {
            to: [recipient.email],
            message: {
              subject: 'An appointment has been allocated to you',
              text: 'Hi ' + recipient.name + ', \n' +
              'The details of the appointment are as follows:\n' +
              'Created by: ' + this.new_booking.created_by_name +'\n' +
              'Customer Name: ' + this.new_booking.customer_name + '\n' +
              'Customer Phone: ' + this.new_booking.customer_phone + '\n' +
              'Customer Phone: ' + this.new_booking.customer_phone + '\n' +
              'Date: ' + this.new_booking.date + '\n' +
              'time: ' + this.new_booking.time + '\n'
            }
          }

          firebase.firestore().collection('mail').add(email);

          this.new_booking = {
            id: "",
            date: "",
            created_date: "",
            customer_name: "",
            customer_phone: "",
            how_did_you_find_us: "",
            cemetery_name: "",
            funeral_provider: "",
            customer_enquiry: "",
            follower: "",
            created_by: "",
            created_by_name: "",
          };
        });
      });
    },
    set_global_date() {
      var date_time = new Date();
      var dd = String(date_time.getDate()).padStart(2, '0');
      var mm = String(date_time.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = date_time.getFullYear();

      this.today = yyyy + '-' + mm + '-' + dd;
    },
    view_booking(booking) {
      this.original_follower = booking.follower;
      this.viewed_booking = booking;
      this.showModal('modal-view-booking');
    },
    edit_booking() {
      if (this.viewed_booking.follower != this.original_follower) {
        firebase.firestore().collection("users").where("name", "==", this.viewed_booking.follower).onSnapshot((collection) => {
          var results = collection.docs.map(doc => doc.data());
          var recipient = results[0]
          
          var email = {
            to: [recipient.email],
            message: {
              subject: 'An appointment has been allocated to you',
              text: 'Hi ' + this.viewed_booking.follower + ', \n' + '\n' +
              'The details of the appointment are as follows:\n' + '\n' +
              'Created by: ' + this.viewed_booking.created_by_name +'\n' +
              'Customer Name: ' + this.viewed_booking.customer_name + '\n' +
              'Customer Phone: ' + this.viewed_booking.customer_phone + '\n' +
              'Customer Phone: ' + this.viewed_booking.customer_phone + '\n' +
              'Date: ' + this.viewed_booking.date + '\n' +
              'time: ' + this.viewed_booking.time + '\n'
            }
          }

          firebase.firestore().collection('mail').add(email);
          
          this.viewed_booking.year_month = this.viewed_booking.date.substring(0, 7);
          this.viewed_booking.day = parseInt(this.viewed_booking.date.substring(8,10));
          firebase.firestore().collection("bookings").doc(this.viewed_booking.id)
            .set(this.viewed_booking,
              {merge: true})
            .then(() => {
              this.hideModal('modal-view-booking');
              alert("Modify successfully");
            });
        });
      } else {
        this.viewed_booking.year_month = this.viewed_booking.date.substring(0, 7);
        this.viewed_booking.day = parseInt(this.viewed_booking.date.substring(8,10));
        firebase.firestore().collection("bookings").doc(this.viewed_booking.id)
            .set(this.viewed_booking,
              {merge: true})
            .then(() => {
              this.hideModal('modal-view-booking');
              alert("Modify successfully");
            });
      }
    },
    cleanFilterInfo() {
      this.filterCriteria = '';
    },
  }
})
</script>